import { render } from "./Investigation.Board.vue?vue&type=template&id=2f731bcc"
import script from "./Investigation.Board.vue?vue&type=script&lang=js"
export * from "./Investigation.Board.vue?vue&type=script&lang=js"

import "./Investigation.Board.vue?vue&type=style&index=0&id=2f731bcc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__